var map = {
	"./0_Dusty.mp3": "7b1e",
	"./3_Tom.mp3": "25a1",
	"./4_Lisa.mp3": "5938",
	"./M_Brilliant.mp3": "7372",
	"./M_Excellent.mp3": "30fc",
	"./M_Fantastic.mp3": "c29a",
	"./M_Great.mp3": "48ea",
	"./M_Perfect.mp3": "a383",
	"./M_Think again.mp3": "14e7",
	"./M_Try again.mp3": "2872",
	"./M_Very good.mp3": "7cac",
	"./M_Well done.mp3": "dec4",
	"./M_Work harder.mp3": "5829",
	"./click.mp3": "e322"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f59b";